var map = {
	"./Broad-billed Hummingbird_1.jpg": 7390,
	"./Broad-tailed Hummingbird_6.jpg": 9008,
	"./Greater Roadrunner_2.jpg": 4698,
	"./Indigo Bunting_5.jpg": 5222,
	"./Painted Bunting_21.jpg": 4323,
	"./Painted Bunting_29.jpg": 6187,
	"./Painted Bunting_3.jpg": 6641,
	"./Painted Bunting_31.jpg": 9760,
	"./Scissor-tailed Flycatcher_4.jpg": 2889,
	"./WM_HermitWarbler_VIN_9345-Enhanced-NR-Edit.jpg": 8041
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5240;